import { render, staticRenderFns } from "./AddUpdatePlantool.vue?vue&type=template&id=ab969afc&scoped=true&"
import script from "./AddUpdatePlantool.vue?vue&type=script&lang=js&"
export * from "./AddUpdatePlantool.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdatePlantool.vue?vue&type=style&index=0&id=ab969afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab969afc",
  null
  
)

export default component.exports